const typOpony = { t: 'Rodzaj opony', name: 'rodzaj-opony', hint: { url: '/tire_kind' }}
export default typOpony